function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.933 4C19.523 4 20 4.478 20 5.067v13.866c0 .59-.478 1.067-1.067 1.067H5.067A1.067 1.067 0 014 18.937V5.067C4 4.477 4.478 4 5.067 4zm-4.838 2.94a5.477 5.477 0 10-4.191 10.12 5.477 5.477 0 004.191-10.12zm-3.92 2.735a.5.5 0 01.5.5v3.651a.5.5 0 01-1 0v-3.651a.5.5 0 01.5-.5zm3.65 0a.5.5 0 01.5.5v3.651a.5.5 0 11-1 0v-3.651a.5.5 0 01.5-.5z"
});

function SvgInternationalPlug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgInternationalPlug;